import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapMembersSearchComponent } from './components/bootstrap-members-search/bootstrap-members-search.component';

const routes: Routes = [{
  path: '', component: BootstrapMembersSearchComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MembersSearchRoutingModule { }
